import React, { useEffect, useState, useRef } from 'react';
import { Grid, Dialog, ListItem } from '@material-ui/core';
import { Text, Colors, PrimaryButton } from 'library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { client, consoleLogInDev } from 'shared';
import { useModalsContext } from 'ModalsContext';

const JobSelection = ({
    open,
    onClose,
    selectJob,
}: {
    open: boolean;
    onClose: () => void;
    selectJob: (e: any) => void;
}) => {
    const [jobs, setJobs] = useState<Array<any>>();
    const scrollElementRef = useRef<HTMLDivElement>(null);
    const { openJobForm } = useModalsContext();

    useEffect(() => {
        getUnfilledJobs();
    }, []);

    function getUnfilledJobs() {
        client('api/ongoing/unfilled_user_requests/?sharing=True')
            .then((jobs) => setJobs(jobs))
            .catch(consoleLogInDev);
    }

    const headline = (job: any) => {
        return (
            <Text variant="body1" bold={true}>
                {job.headline}
            </Text>
        );
    };

    const frequency = (job: any) => {
        return (
            <Grid container direction="row">
                <Text variant="body2">{job.ongoing ? 'Weekly' : 'One time'} &bull;&nbsp;</Text>
                <Grid>
                    {job.days_of_job.map((day: string, i: number) => (
                        <Text variant="body1">
                            {day}
                            {i < job.days_of_job.length - 1 ? ', ' : null}
                        </Text>
                    ))}
                </Grid>
            </Grid>
        );
    };

    const dates = (job: any) => {
        if (job.start_date && job.end_date) {
            return (
                <Grid container direction="row">
                    <Text variant="body2">{moment(job.start_date).format('l')}</Text>
                    {job.ongoing ? (
                        <>
                            <Text variant="body2">-</Text>
                            <Text variant="body2">{moment(job.end_date).format('l')}</Text>
                        </>
                    ) : null}
                </Grid>
            );
        } else if (job.start_month) {
            return (
                <Grid container direction="row">
                    <Text variant="body2">{job.start_month}</Text>
                </Grid>
            );
        } else {
            return <></>;
        }
    };

    const postAJob = () => {
        onClose();
        openJobForm('Newsfeed share a job', undefined, getUnfilledJobs);
    };

    const noOpenJobs = () => {
        return (
            <Grid lg={12} style={{ paddingLeft: 20 }}>
                <Text variant="body1">It looks like you have no open jobs.</Text>
                <Grid container lg={12} justify="flex-end" style={{ marginTop: 20 }}>
                    <Grid lg={5} item>
                        <PrimaryButton onClick={postAJob}>Make a job request</PrimaryButton>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={'sm'}
            fullWidth={true}
            PaperProps={{
                style: {
                    borderRadius: 20,
                    padding: 16,
                },
            }}
        >
            <Grid style={{ padding: 20 }}>
                <Text variant="h1" bold={true}>
                    Share Job
                </Text>
            </Grid>
            <Grid container justify="center" ref={scrollElementRef} style={{ overflow: 'auto', maxHeight: 940 }}>
                {jobs && jobs.length > 0
                    ? jobs.map((job) => (
                          <ListItem
                              button
                              divider
                              onClick={() => {
                                  onClose();
                                  selectJob(job);
                              }}
                          >
                              <div
                                  style={{
                                      backgroundColor: Colors.lightGrey,
                                      minWidth: 35,
                                      minHeight: 35,
                                      borderRadius: '50%',
                                      alignItems: 'flex-start',
                                      marginRight: 12,
                                  }}
                              >
                                  <Grid container item alignItems="center" justify="center" style={{ marginTop: 8 }}>
                                      <FontAwesomeIcon icon={faBriefcase} color={Colors.darkNavy} size="lg" />
                                  </Grid>
                              </div>
                              <Grid container direction="column">
                                  {headline(job)}
                                  {frequency(job)}
                                  {dates(job)}
                              </Grid>
                          </ListItem>
                      ))
                    : noOpenJobs()}
            </Grid>
        </Dialog>
    );
};

export default JobSelection;
